import React from 'react';

import type { TStickyWrapper } from './models';

export const StickyWrapper: TStickyWrapper = ({ children, isSticky, style, styles }) => {
    const { top, transform } = style;

    return (
        <div className={isSticky ? styles.sticked : undefined} style={{ transform, top }}>
            {children}
        </div>
    );
};
